import React, { Component } from "react";
import { connect } from "react-redux";
import { IntlProvider, addLocaleData } from "react-intl";
import { Container } from "react-bootstrap";
import en from "react-intl/locale-data/en";
import pt from "react-intl/locale-data/pt";
import es from "react-intl/locale-data/es";
import messages from "./../../assets/i18n";

//Adicionando os Locales
addLocaleData(pt);
addLocaleData(en);
addLocaleData(es);

class Load extends Component {

    componentDidMount() {
        const { idLoad, gate, date, hour  } = this.props.scheduling;
        this.props.saveScheduling(idLoad, gate, date, hour );
    }

    render() {
        const { lang, scheduling } = this.props;

        return (
            <IntlProvider
                locale={lang.name}
                key={lang.name}
                messages={messages[lang.name]}
                defaultLocale={lang.name}
            >
                <Container>
                    <p>{JSON.stringify(scheduling)}</p>
                </Container>
            </IntlProvider>
        );
    }
}

const mapStateToProps = state => ({
    lang: state.language,
    scheduling: state.scheduling
});

const mapDispatchToProps = dispatch => {
    return {
        saveScheduling: (idCarga, idPortao, date, hour) =>
            dispatch({
                type: "SAVE_SCHEDULING",
                idCarga: idCarga, 
                idPortao: idPortao,
                dtEntrega: date,
                horaEntrega: hour
            })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Load);
